module.exports = __webpack_public_path__ + "img/who.1c72b479.svg";